<header *ngIf="!isOnboarding" class="wrapper not-printable" [class.mobile-menu-open]="isMobileMenuOpen">
  <div class="header-content-left">
    <button mat-button class="logo-btn" (click)="toggleModuleMenu(); $event.stopPropagation()">
      <div class="logo-mark">B</div>
      <span class="logo-text">Bizcombo</span>
    </button>
    <button *ngIf="loginDisplay" mat-icon-button
            matTooltip="Select modules"
            (click)="toggleModuleMenu(); $event.stopPropagation()">
      <mat-icon class="apps-icon">apps</mat-icon>
    </button>
  </div>

  <!-- Inline Navigation -->
  <nav class="header-nav" *ngIf="loginDisplay && menu?.length">
    <ng-container *ngFor="let item of menu">
      <a class="nav-item"
         [class.active]="isNavItemActive(item)"
         [matMenuTriggerFor]="item.children ? navMenu : null"
         [href]="getNavItemHref(item)"
         (click)="onNavItemClick(item, $event)">
        <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
        <span>{{ item.name }}</span>
        <mat-icon *ngIf="item.children" class="nav-dropdown-arrow">expand_more</mat-icon>
      </a>

      <!-- Dropdown for items with children -->
      <mat-menu #navMenu="matMenu" class="nav-dropdown-menu">
        <ng-container *ngIf="item.children">
          <ng-container *ngFor="let child of item.children; let ci = index">
            <!-- If child has sub-children, show group label + sub-items -->
            <ng-container *ngIf="child.children && child.children.length > 0">
              <div class="nav-dropdown-group-label">{{ child.name }}</div>
              <a mat-menu-item *ngFor="let sub of child.children"
                 [href]="buildNavHref(sub)"
                 (click)="onNavChildClick(sub, $event)">
                <mat-icon>{{ sub.icon }}</mat-icon>
                <span>{{ sub.name }}</span>
              </a>
            </ng-container>
            <!-- If child has no sub-children -->
            <ng-container *ngIf="!child.children || child.children.length === 0">
              <a mat-menu-item
                 [href]="buildNavHref(child)"
                 (click)="onNavChildClick(child, $event)">
                <mat-icon>{{ child.icon }}</mat-icon>
                <span>{{ child.name }}</span>
              </a>
              <!-- Add divider after standalone items if next item has children -->
              <div class="nav-dropdown-divider"
                   *ngIf="item.children[ci + 1]?.children?.length > 0"></div>
            </ng-container>
          </ng-container>
        </ng-container>
      </mat-menu>
    </ng-container>
  </nav>

  <!-- Mobile hamburger toggle (visible only on mobile) -->
  <button *ngIf="loginDisplay"
          mat-icon-button
          class="mobile-menu-toggle"
          [attr.aria-label]="isMobileMenuOpen ? 'Close menu' : 'Open menu'"
          [attr.aria-expanded]="isMobileMenuOpen"
          (click)="toggleMobileMenu(); $event.stopPropagation()">
    <mat-icon class="notification-icon">{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
  </button>

  <div *ngIf="loginDisplay" class="header-content-right">
    <!-- Compact Global Search -->
    <div class="compact-search-container">
      <mat-form-field class="compact-search-field" appearance="outline">
        <mat-icon matPrefix class="search-icon">search</mat-icon>
        <input type="text"
               [placeholder]="getSearchPlaceholder()"
               matInput
               [formControl]="searchControl"
               (focus)="onSearchFocus()"
               (blur)="onSearchBlur()"
               class="search-input"
               autocomplete="off">
        <button *ngIf="searchControl.value || activeSearchFilters.length > 0 || selectedSearchCompanyIds.length > 0" mat-icon-button matSuffix (click)="clearSearch()" class="clear-search-btn">
          <mat-icon>close</mat-icon>
        </button>
        <mat-spinner *ngIf="isSearching" matSuffix diameter="20" class="search-spinner"></mat-spinner>
        <span class="search-shortcut-hint" matSuffix *ngIf="!searchControl.value && activeSearchFilters.length === 0 && selectedSearchCompanyIds.length === 0">
          <kbd>&#8984;K</kbd>
        </span>
      </mat-form-field>

      <!-- Search Results Dropdown -->
      <div class="search-results-dropdown" *ngIf="showSearchFilters || isSearching || (showSearchResults && searchResults.length > 0) || (showSearchResults && searchResults.length === 0 && searchControl.value?.length >= 2)">
        <!-- Filters Section -->
        <div class="search-filters-section" *ngIf="showSearchFilters || activeSearchFilters.length > 0 || selectedSearchCompanyIds.length > 0">
          <div class="filters-label">Filter by:</div>
          <div class="search-filters">
            <button *ngFor="let filter of searchFilterOptions"
                    class="filter-chip"
                    [class.active]="isFilterActive(filter.value)"
                    (mousedown)="toggleSearchFilter(filter.value); $event.preventDefault()">
              <mat-icon class="filter-icon">{{ filter.icon }}</mat-icon>
              <span>{{ filter.label }}</span>
            </button>

            <!-- Company scope multi-select -->
            <button class="filter-chip companies-chip"
                    [class.active]="selectedSearchCompanyIds.length > 0"
                    [matMenuTriggerFor]="companiesScopeMenu"
                    (mousedown)="$event.preventDefault()">
              <mat-icon class="filter-icon">business</mat-icon>
              <span>{{ searchCompanyButtonLabel }}</span>
              <mat-icon class="filter-icon">expand_more</mat-icon>
            </button>

            <mat-menu #companiesScopeMenu="matMenu" class="search-companies-menu">
              <button mat-menu-item
                      (click)="selectAllSearchCompanies(); $event.stopPropagation()">
                <mat-icon>{{ selectedSearchCompanyIds.length === 0 ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                <span>All companies</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item
                      *ngFor="let company of userCompanies"
                      (click)="toggleCompanyFilter(company.id); $event.stopPropagation()">
                <mat-icon>{{ isCompanyFilterActive(company.id) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                <span>{{ company.name }}</span>
              </button>
            </mat-menu>
          </div>
        </div>

        <!-- Loading State -->
        <div class="search-loading" *ngIf="isSearching">
          <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
          <div class="loading-text">
            <mat-spinner diameter="16"></mat-spinner>
            <span>Searching...</span>
          </div>
        </div>

        <!-- Search Results -->
        <ng-container *ngIf="!isSearching && searchResults.length > 0">
          <ng-container *ngFor="let group of searchResults">
            <div class="search-category-header">
              <span>{{ group.category }}</span>
            </div>
            <div class="search-result-item"
                 *ngFor="let result of group.results"
                 (mousedown)="onSearchResultClick(result)">
              <mat-icon class="result-icon">{{ result.icon }}</mat-icon>
              <div class="result-content">
                <span class="result-title">{{ result.title }}</span>
                <span class="result-subtitle">{{ result.subtitle }}</span>
              </div>
              <span class="result-company-chip"
                    *ngIf="result.companyName && result.companyId !== managedCompanyId"
                    [matTooltip]="'In ' + result.companyName">
                <mat-icon class="company-chip-icon">business</mat-icon>
                {{ result.companyName }}
              </span>
              <mat-icon class="result-arrow">chevron_right</mat-icon>
            </div>
          </ng-container>
        </ng-container>

        <!-- No Results Message -->
        <div class="no-results" *ngIf="!isSearching && searchResults.length === 0 && searchControl.value?.length >= 2">
          <mat-icon>search_off</mat-icon>
          <span>No results found</span>
        </div>
      </div>
    </div>

    <!-- Company picker as a mat-menu (not mat-select) so the row body is inert
         by design — only the two explicit buttons trigger anything. -->
    <div id="company-select">
      <button mat-stroked-button
              class="company-picker-trigger"
              matTooltip="Select company"
              [matMenuTriggerFor]="companyMenu"
              #companyMenuTrigger="matMenuTrigger"
              (menuOpened)="onCompanyMenuOpened()">
        <mat-icon class="company-icon">business</mat-icon>
        <span class="company-picker-name">{{ currentCompanyName }}</span>
        <mat-icon class="company-picker-arrow">expand_more</mat-icon>
      </button>

      <mat-menu #companyMenu="matMenu" class="company-picker-menu" xPosition="before">
        <!-- Stop propagation on the filter so typing/clicking doesn't close the menu. -->
        <div class="company-picker-filter"
             (click)="$event.stopPropagation()"
             (keydown)="$event.stopPropagation()">
          <input class="company-picker-filter-input"
                 #companyFilter
                 placeholder="Search..."
                 type="text"
                 (keyup)="onCompanySearch(companyFilter.value)">
        </div>

        <div class="company-picker-list">
          <div *ngFor="let company of filteredCompanies"
               class="company-picker-row"
               [class.current]="company.id === currentCompanyIdFromStorage"
               (click)="$event.stopPropagation()">
            <span class="company-picker-row-label">{{ company.name }}</span>
            <span class="company-picker-row-actions" *ngIf="company.id !== currentCompanyIdFromStorage">
              <button mat-icon-button
                      class="open-company-form-btn"
                      matTooltip="View as client (new tab)"
                      aria-label="View as client in new tab"
                      (click)="openCompanyAsForm(company.id, $event)">
                <mat-icon>open_in_new</mat-icon>
              </button>
              <button *ngIf="isAdmin"
                      mat-icon-button
                      class="org-settings-btn"
                      matTooltip="Organization settings (new tab)"
                      aria-label="Open organization settings in new tab"
                      (click)="openCompanySettings(company.id, $event)">
                <mat-icon>settings</mat-icon>
              </button>
              <button mat-icon-button
                      class="switch-company-btn"
                      matTooltip="Switch to this company"
                      aria-label="Switch to this company"
                      (click)="switchToCompany(company.id, $event)">
                <mat-icon>swap_horiz</mat-icon>
              </button>
            </span>
            <mat-icon *ngIf="company.id === currentCompanyIdFromStorage" class="company-picker-current-icon">check</mat-icon>
          </div>
        </div>
      </mat-menu>
    </div>

    <!-- AI Chat Button -->
    <button
      mat-icon-button
      class="header-icon-btn"
      [class.ai-chat-active]="aiChatPanelService.isOpen"
      matTooltip="AI Assistant"
      aria-label="Open AI assistant"
      (click)="toggleAiChat(); $event.stopPropagation()">
      <mat-icon class="notification-icon">smart_toy</mat-icon>
    </button>

    <!-- Phonebook Button — opens the slide-in panel; Ctrl/⌘/middle-click opens the full page in a new tab -->
    <a
      mat-icon-button
      matTooltip="Contacts (Ctrl/⌘-click for new tab)"
      aria-label="Open contacts"
      [href]="phonebookUrl"
      (click)="onContactsClick($event)"
      (auxclick)="$event.stopPropagation()">
      <mat-icon class="notification-icon">contacts</mat-icon>
    </a>

    <!-- Add Contact Button (available on every page) -->
    <button
      mat-icon-button
      matTooltip="Add contact"
      aria-label="Add contact"
      (click)="addContact(); $event.stopPropagation()">
      <mat-icon class="notification-icon">person_add</mat-icon>
    </button>

    <!-- Notes Button -->
    <button
      mat-icon-button
      class="header-icon-btn"
      [class.meeting-notes-active]="meetingNotesPanelService.isPanelOpen"
      matTooltip="Notes"
      aria-label="Open notes"
      (click)="toggleMeetingNotesPanel(); $event.stopPropagation()">
      <mat-icon
        aria-hidden="false"
        [matBadge]="(meetingNotesPanelService.unreadCount$ | async) > 0 ? (meetingNotesPanelService.unreadCount$ | async) : null"
        matBadgeColor="warn"
        matBadgeSize="small"
        matBadgePosition="above after"
        class="notification-icon">
        assignment
      </mat-icon>
    </button>

    <!-- Notification Dropdown -->
    <app-notification-dropdown
      [notifications]="notifications"
      [unreadCount]="unreadCount"
      [isAdmin]="isAdmin"
      [isLoading]="isLoading"
      [companies]="userCompanies || []"
      [currentCompanyId]="currentCompanyIdFromStorage"
      (markAsRead)="markAsRead($event.note, $event.index)"
      (markAllAsRead)="markAllAsRead()"
      (deleteNotification)="deleteNotification($event.note, $event.index)"
      (viewLeave)="viewPendingLeaves($event)"
      (viewAll)="navigateToNotifications()"
      (openSettings)="navigateToNotificationSettings()">
    </app-notification-dropdown>

    <div class="user-avatar" matTooltip="{{currentUser?.email}}" (click)="navigateToSettings(); $event.stopPropagation()">
      {{ currentUser?.email ? currentUser.email.substring(0, 2).toUpperCase() : 'U' }}
    </div>
  </div>

  <!-- Module Menu (inside header for proper z-index stacking) -->
  <div class="module-menu-wrapper" *ngIf="isModuleMenuOpen">
    <mat-card>
      <mat-card-content>
        <div class="module-menu-content">
          <div *ngFor="let module of modules$ | async; let i = index">
            <div *ngxPermissionsOnly="permissions[i]" class="module-btn-row">
              <button mat-button (click)="selectModule(module.id)" class="menu-btn">
                <div class="btn-content">
                  <div class="icon-wrapper">
                    <img class="btn-menu-icon" [src]="module.icon" [alt]="module.name"/>
                  </div>
                  <div class="white">{{ module.name }}</div>
                </div>
              </button>
              <button mat-icon-button class="open-tab-btn" matTooltip="Open in new tab"
                      (click)="openModuleInNewTab(module.id); $event.stopPropagation()">
                <mat-icon class="open-tab-icon">open_in_new</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Settings Panel (inside header for proper z-index stacking) -->
  <div class="settings-wrapper" *ngIf="isSettingsOpen">
    <mat-card>
      <mat-card-header>
        <h2>Settings</h2>
      </mat-card-header>
      <mat-card-content>
        <div class="settings-menu">
          <div *ngFor="let setting of settings">
            <a class="setting-link" (click)="hideAfterClick()" [routerLink]="setting.link">
              <mat-icon>
                {{setting.icon}}
              </mat-icon>
              <span class="setting-title">{{setting.name}}</span>
            </a>
          </div>
          <div *ngxPermissionsOnly="['PermissionsAdmin', 'SuperAdmin']" class="module-menu-content">
            <a routerLink="settings/permissions" class="setting-link" (click)="hideAfterClick()" [style.cursor]="'pointer'">
              <mat-icon>
                admin_panel_settings
              </mat-icon>
              <span class="setting-title">User permissions</span>
            </a>
          </div>
          <div *ngxPermissionsOnly="['CorporateAdmin']" class="module-menu-content">
            <a routerLink="corporate/risk-settings" class="setting-link" [style.cursor]="'pointer'">
              <mat-icon>
                assessment
              </mat-icon>
              <span class="setting-title">Risk assessment</span>
            </a>
            <a routerLink="admin/pending-changes" class="setting-link" [style.cursor]="'pointer'">
              <mat-icon>
                rule
              </mat-icon>
              <span class="setting-title">Pending Changes</span>
            </a>
          </div>
          <div class="settings-menu">
            <a (click)="onLogout()" class="setting-link" [style.cursor]="'pointer'">
              <mat-icon>
                logout
              </mat-icon>
              <span class="setting-title">Log out</span>
            </a>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</header>
